import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api';
import { API_BASE_URL } from '../constants/consts';
import { authFirewallQueryKeys } from '../constants/queryKeys';
import type { ApiError } from '../types';

const END_POINT = '/metrics/lastSync';

const fetchLastSync = async (): Promise<Date | null> => {
    const data = await apiGet<{ lastSync: string | null }>(`${API_BASE_URL}${END_POINT}`);
    return data.lastSync ? new Date(data.lastSync) : null;
};

export const useLastSync = (): UseQueryResult<Date | null, ApiError> => {
    return useQuery({
        queryKey: authFirewallQueryKeys.lastSync(),
        queryFn: () => fetchLastSync(),
        refetchInterval: 60000
    });
};
